<template>
  <div :class="{'spl-message-modal-holder-show': isVisible}" class="spl-message-modal-holder">
    <div class="spl-message-modal spl-message-modal__info">
      <div class="spl-message-modal__label">
        Please select the return parcel
      </div>
      <!-- Lists Parcels that can be selected as a source for a return -->
      <div v-for="(parcel, index) in parcels" :key="'returnParcelSelectModal' + index">
        <button class="spl-return-modal__parcel" @click="clicked(parcel.Parcel_ID)">
          <span :class="isDateBefore(parcel) ? 'spl-return-modal__parcel--red' : ''">{{ formatDate(parcel.Booked_Pickup_Date, true,'YYYY-MM-DD') }}</span>
          <span>{{ parcel.References[0].Reference_Text }}</span><br>
          <span>{{ parcel.Delivery_Name_1 + ', ' + parcel.Delivery_Street_1 + ', ' + parcel.Delivery_Postal_Code + ' ' + parcel.Delivery_City + ', ' + parcel.Delivery_Country_Name }}</span>
          <span>{{ parcel.Contact_Name }}</span>
        </button>
      </div>

      <form-button
        class="spl-next-button"
        @onClick="cancelSelection">
        Cancel
      </form-button>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import moment from 'moment'
export default {
  name: 'ReturnParcelSelectModal',
  mixins: [Helpers],
  props: ['parcels', 'isVisible'],
  data () {
    return {
    }
  },
  mounted () {
  },

  methods: {
    // adds a warning to the source parcel if it is too old
    isDateBefore (parcel) {
      return moment(parcel.Booked_Pickup_Date).add(2, 'months').isBefore()
    },
    cancelSelection () {
      this.$emit('cancel')
    },
    clicked (selectedParcelID) {
      this.$emit('parcelSelcted', selectedParcelID)
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";
.spl-return-modal__parcel {
  width: 100%;
  background-color: #feba35;
  border: none;
  border-radius: 4px;
  color: #191716;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 20px;
  margin-bottom: 15px;
  text-align: left;
  &--red {
    color: red
  }
  span {
    padding-right: 5px;
  }
}

.spl-message-modal-holder {
  background-color: rgba(0, 0, 0, 0.5);
  display: none;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 90000;
  overflow: auto;

  &-show {
    display: block;
  }
  .spl-message-modal {
    left: 50%;
    padding: 20px 15px 30px 15px;
    position: absolute !important;
    top: 25%;
    transform: translate3d(-50%, 0, 0);
    width: 700px;
    .spl-next-button {
      margin: 15px 0 0 15px;
    }
    @include mobile() {
      left: $mobilePadding;
      transform: translate3d(0, 0, 0);
      top: $mobilePadding;
      width: calc(100% - #{$mobilePadding*2});
    }
    &__error {
      background-color: $redBackground;
    }
    &__success {
      background-color: $grayBackground;
    }
    &__warning {
      background-color: $lightYellow;
    }
    &__info {
      background-color: $lightYellow;
    }
    &__label {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 20px;
    }
    &__close {
      background-image: url(../../assets/icon-close.svg);
      background-position: center center;
      background-repeat: no-repeat;
      cursor: pointer;
      height: 25px;
      position: absolute;
      right: 10px;
      top: 20px;
      transition: opacity $shortTransition ease-in-out;
      width: 25px;

      &:hover {
        opacity: 0.5;
      }
    }
    &__content {
      padding-bottom: 10px;
    }
    .spl-message-label {
      color: $parcelDetailBlockLabelColor;
    }
    .spl-message-button {
      margin-bottom: 0;
    }
  }
}
</style>
